import React from 'react';
import {
  Modal,
  Fade,
  Backdrop,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useLocation } from 'react-router-dom';
import ButtonBase from '../Buttons/ButtonBase';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { showLoading, hideLoading } from '../../store/actions/LoadingActions';
import { showNewTerms, changeTerms } from '../../store/actions/UserAction';
import * as ROUTES from '../../routes';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    maxWidth: 560,
    width: '100%',
    borderRadius: 4,
    padding: '56px 60px 104px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
    '@media screen and (max-width: 768.98px)': {
      margin: '0 16px',
      padding: '40px 16px 64px',
    }
  },
  infoWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
  },
  name: {
    fontSize: 28,
    color: '#10587f',
    textAlign: 'center',
    fontWeight: 'bold',
    margin: '0 auto 32px',
    width: '85%',
    '@media screen and (max-width: 768.98px)': {
      width: '100%',
      fontSize: 22,
      margin: '0 auto 34px',
    }
  },
  subname: {
    fontSize: 16,
    color: '#484848',
    textAlign: 'center',
    margin: '0 auto 32px',
    width: '88%',
    '@media screen and (max-width: 768.98px)': {
      width: '100%',
      maxWidth: 400,
      margin: '0 auto 31px',
    }
  },
  clickHere: {
    color: '#35b9b6',
    fontWeight: 'bold',
    textDecoration: 'none',
  },
  space: {
    display: 'block',
    '@media screen and (max-width: 768.98px)': {
      display: 'none'
    }
  },
  divider: {
    width: '100%',
    margin: '0 0 23px',
    border: '1px solid #e7e7e7'
  },
  // Form
  formControlLabelRoot: {
    width: '90%',
    margin: 'auto',
    '@media screen and (max-width: 768.98px)': {
      maxWidth: 400,
    },
  },
  label: {
    color: '#484848',
    fontSize: 14,
    lineHeight: 'normal',
    margin: 0,
    paddingLeft: 0,
  },
  accept: {
    margin: '8px 0 0',
  },
  linkStyle: {
    minWidth: '94%',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    '@media screen and (max-width: 768.98px)': {
      minWidth: '96%',
    }
  },
  buttonStyle: {
    minWidth: 'inherit',
    margin: '54px 0 0',
  }
})

const ModalNewTerms = ({ 
    authClient,
    showNewTerms,
    changeTerms,
    newTermsModal,
    showLoading,
    hideLoading,
}) => {

    const classes = useStyles()
    const location = useLocation()

    const handleSubmit = async (values) => {
      try {
        showLoading()
        await changeTerms(values.newTerms, authClient.uid)
        hideLoading()
        showNewTerms(false)
      } catch (error) {
        console.log('error', error);
        hideLoading()
      }
    };

    const isOpen = () => {
      if (
        (location.pathname &&
        location.pathname.includes('informacion-adicional'))
      ) {
        return false
      } else if (newTermsModal) {
        return true
      } else {
        return false
      }
    }

    const initialValues = {
      newTerms: false
    }

    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isOpen()}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={isOpen()}>
          <div className={classes.paper}>
            <div className={classes.infoWrapper}>

              <p className={classes.name}>
                Los términos y condiciones han cambiado
              </p>

              <div className={classes.subname}>
                Los términos y condiciones y política de privacidad<br className={classes.space}/> de
                Contacta Abogado® han cambiado, para continuar
                navegando es necesario que leas y aceptes los términos y
                condiciones, <a
                href={ROUTES.ADDITIONAL_INFO}
                target='_blank'
                rel="noopener noreferrer"
                className={classes.clickHere}
              >para leerlos da click aquí</a>.
              </div>

              <hr className={classes.divider}/>
              
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                render={props => (
                  <NewTermsForm
                    {...props}
                    style={classes}
                  />
                )}
              />
              
            </div>
          </div>
        </Fade>
      </Modal>
    )
}

const NewTermsForm = ({
  values,
  handleSubmit,
  handleChange,
  style,
}) => {
  return (
    <>
      <FormControlLabel
        classes={{
          root: style.formControlLabelRoot,
        }}
        control={
          <Checkbox
            name="newTerms"
            checked={values.newTerms}
            onChange={handleChange}
            label="Gilad Gray"
            classes={{
              root: style.checkPadding,
            }}
          />
        }
        label={
          <div
            className={style.label}
          >
            <p className={style.accept}>
              Acepto que he leído los <b>términos y condiciones
              y política de privacidad</b> de Contacta Abogado®
            </p>
          </div>
        }
      />
      <ButtonBase
        type="submit"
        onClick={handleSubmit}
        variant="primary"
        disabled={values.newTerms ? false : true}
        linkStyle={style.linkStyle}
        buttonStyle={style.buttonStyle}
      >
        Continuar navegando
      </ButtonBase>
    </>
  )
}

const mapStateToProps = state => ({
  authClient: state.authClient,
  newTermsModal: state.authClient.newTermsModal,
})

const mapDispatchToProps = dispatch => ({
  showNewTerms: (open, role) => dispatch(showNewTerms(open, role)),
  changeTerms: (value, uid) => dispatch(changeTerms(value, uid)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalNewTerms);
